import { useApi } from '@/hooks/useApi';
import { useOne } from '@refinedev/core';
import { IInvoice } from '../model/invoice';

const RESOURCE = 'invoices';

export const useInvoiceService = () => {
  const { sendBasicRequest } = useApi();

  function getById(id: string) {
    // TODO: React Hook is called in function
    return useOne<IInvoice>({
      resource: RESOURCE,
      id,
    });
  }

  function getSummary(id: string) {
    return sendBasicRequest(
      `/${RESOURCE}/${id}/summary`,
      'GET',
    );
  }

  function getAwbById(id: string) {
    return sendBasicRequest(
      `/${RESOURCE}/${id}/items`,
      'GET',
    );
  }

  function getPayment(id: string) {
    return sendBasicRequest(
      `/${RESOURCE}/${id}/payments`,
      'GET',
    );
  }

  function getDetailAwbInvoice(id: string) {
    return sendBasicRequest(
      `/${RESOURCE}/${id}/awbs`,
      'POST',
      {},
    );
  }

  return {
    getById,
    getAwbById,
    getPayment,
    getSummary,
    getDetailAwbInvoice,
  };
};

export default useInvoiceService;
